import { useQuery } from '@tanstack/react-query';
import { falconClient } from '@/data/@clients';
import {
  type Resource,
  type ResourceCatalog,
} from '@/data/resource-catalog/interfaces';

const baseUrl = '/api/resource_catalog';

export const useResourcesIndex = ({
  videoIds,
}: { videoIds?: number[] } = {}) => {
  const params = videoIds ? { video_ids: videoIds.join(',') } : {};

  const response = useQuery<ResourceCatalog>({
    queryKey: ['useIndex', videoIds],
    queryFn: async () =>
      await falconClient.get(`${baseUrl}/resources`, { params }),
  });

  return {
    videos: response.data?.resource?.youtube_video ?? [],
    ...response,
  };
};

export const useResourceShow = ({ videoId }: { videoId: string }) => {
  const response = useQuery<Resource>({
    queryKey: ['useShow', videoId],
    queryFn: async () =>
      await falconClient.get(`${baseUrl}/resources/${videoId}`),
  });

  return {
    video: response.data?.resource?.youtube_video ?? null,
    ...response,
  };
};
